import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usertab: 0,
    
  },
  mutations: {
    setuser(state,count){
      state.usertab = count
    },
    setSearchList(state,search) {
      state.searchList.push(search)
    }
  },
  actions: {

  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/util/store/index.js